angular.module("digitalLeasing.module").component("financialAppropriateVerification", {
    templateUrl: "ng/components/digitalLeasing/financialAppropriateVerification/financialAppropriateVerification.view.html",
    bindings: {
        model: "=",
        exportValue: '&',
        digitalNavigator: "<?",
        readOnly: "<?"
    },
    controllerAs: "finAppropriateVerificationCtrl",
    controller: FinAppropriateVerificationController
});

function FinAppropriateVerificationController(
    $uniService,
    $rootScope
) {
    var self = this;

    self.$onInit = function () {
        self.waitForRest = true;
        jQuery(".financial-leasing__footer").css("z-index", "-1");
        startQuestionario();

    }

    var startQuestionario = function () {
        $uniService.startQuestionarioDigital(self.model.leasingData.id, self.readOnly)
            .then(function (response) {
                if (response.success) {
                    self.responseStarQuestionario = response.adv;
                    self.questionarioAdv = response.adv.metadataAdv;
                }
                self.waitForRest = false;
                jQuery(".financial-leasing__footer").css("z-index", "2");
            })
            .catch(function (error) {
                console.log(error);
                self.waitForRest = false;
                jQuery(".financial-leasing__footer").css("z-index", "2");
            })
    }


    self.modelQuestADV = function (responseQuestionarioADV, enableSubmitButton, newAdded) {

        self.exportValue({
            responseQuestionario: responseQuestionarioADV,
            enableNextButton: enableSubmitButton,
            newAdded: newAdded
        })
    }


}